import { requestApi } from 'api/api'
import type {
  CreateLimitPayload,
  Limit,
  LimitsQueryParams,
  LimitsResponse,
  UpdateLimitPayload,
} from 'types/paymentLimits'

const buildLuceneQuery = (params: LimitsQueryParams): string => {
  const queryFields: Array<{ key: string; value: string | undefined }> = [
    { key: 'accountId', value: params?.accountId },
    { key: 'customerId', value: params?.customerId },
    { key: 'walletId', value: params?.walletId },
    { key: 'paymentMethod', value: params?.paymentMethod },
    { key: 'limitType', value: params?.limitType },
    { key: 'currency', value: params?.currency },
  ]

  return queryFields
    .filter(({ value }) => !!value)
    .map(({ key, value }) => `${key}:${value}`)
    .join(' AND ')
}

export const getPaymentLimits = async (params: LimitsQueryParams): Promise<LimitsResponse> => {
  const q = buildLuceneQuery(params)

  return requestApi({
    url: '/governance/v1/limits',
    method: 'GET',
    params: {
      ...(q && { q }),
      ...(params?.pageNumber !== undefined && { pageNumber: params.pageNumber }),
      ...(params?.pageSize && { pageSize: params.pageSize }),
    },
    baseUrl: process.env.API_URL,
  })
}

export const createPaymentLimit = async (data: CreateLimitPayload): Promise<Limit> => {
  return requestApi({
    url: '/governance/v1/limits',
    method: 'POST',
    data,
    baseUrl: process.env.API_URL,
  })
}

export const updatePaymentLimit = async ({
  ruleId,
  ...data
}: UpdateLimitPayload): Promise<Limit> => {
  return requestApi({
    url: `/governance/v1/limits/${ruleId}`,
    method: 'PUT',
    data,
    baseUrl: process.env.API_URL,
  })
}
